export default "__VITE_ASSET__170df89e__"